import { initializeApp } from "firebase/app";
import { getAnalytics as getAnalyticsFirebase } from "firebase/analytics";
// import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
// import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const app = initializeApp({
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
});

// connectFirestoreEmulator(getFirestore(app), "localhost", 8080);
// connectFunctionsEmulator(getFunctions(app), "localhost", 5001);

export default app;

export const getAnalytics = () => getAnalyticsFirebase(app);
